import * as PIXI from "pixi.js";

export const backgroundGrid = new PIXI.Graphics();
backgroundGrid.beginFill(0); // color doesn't matter here
backgroundGrid.drawRect(0, 0, 1000, 1000);
backgroundGrid.endFill();
